// services/newsService.ts
import { NewsCreateDTO, NewsQuery, NewsUpdateDTO } from '../models/news';
import apiClient from './api';

export const getNews = async (newsID: number) => {
  const response = await apiClient.get(`/news/${newsID}`);
  return response.data;
};

export const getNewsByQuery = async (query: NewsQuery) => {
  const params = {
    moduleID: query.ModuleID?.toString() || '',
    newsTypeID: query.newsTypeID?.toString() || '',
    departmentID: query.departmentID?.toString() || '',
    pageIndex: query.pageIndex?.toString() || '1',
    pageSize: query.pageSize?.toString() || '5',
    publishDateStart: query.publishDateStart?.toString() || '',
    publishDateEnd: query.publishDateEnd?.toString() || '',
    unpublishDateStart: query.unpublishDateStart?.toString() || '',
    unpublishDateEnd: query.unpublishDateEnd?.toString() || '',
  };

  const response = await apiClient.get(`/news`, { params });
  return response.data;
};

export const createNews = async (news: NewsCreateDTO) => {
  const response = await apiClient.post(`/news`, news);
  return response.data;
};

export const updateNews = async (news: NewsUpdateDTO) => {
  const response = await apiClient.put(`/news`, news);
  return response.data;
};

export const deleteNews = async (newsID: number) => {
  const response = await apiClient.delete(`/news/${newsID}`);
  return response.data;
}

export const markAsRead = async (newsID: number, userID: number) => {
  const response = await apiClient.post(`/news/markRead`, { newsID, userID });
  return response.data;
};
